import CardsList from "./cards-list";
export default CardsList
